import React from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { Box, Typography, useTheme } from "@mui/material";
import { MyTimesheetCalendarTooltipState } from "my-timesheet/components";

interface Event {
  start: Date | string;
  end: Date | string;
  title?: string;
  projectName?: string;
  clientName?: string;
  state?: string;
}

export const MyTimesheetCalendarTooltip = ({ event }: { event: Event }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  if (!event) return null;

  const startTime = moment(event?.start).format("HH:mm") || "";
  const endTime = moment(event?.end).format("HH:mm") || "";

  return (
    <Box
      style={{
        minWidth: "226px",
        textAlign: "center",
        fontSize: "12px",
        lineHeight: "16px",
        letterSpacing: "0.4px",
      }}
    >
      <Box paddingBottom={"4px"}>
        <Typography variant="caption" color="white.main">
          {event?.title}
        </Typography>
      </Box>
      {event?.projectName && (
        <Box paddingBottom={"4px"}>
          <Typography variant="body2" color="gray60.main">
            {event?.projectName}
          </Typography>
        </Box>
      )}
      {event?.clientName && (
        <Box paddingBottom={"4px"}>
          <Typography variant="body2" color="gray60.main">
            {event?.clientName}
          </Typography>
        </Box>
      )}
      <Box
        style={{
          height: "1px",
          backgroundColor: theme.palette.gray50.main,
          marginBottom: "4px",
        }}
      />
      <Typography variant="caption" color="white.main">
        {`${startTime} - ${endTime}`}
      </Typography>

      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        paddingTop="4px"
      >
        <Box width="50%" textAlign="right" paddingRight="2px">
          {t("OC_STATE")}
        </Box>
        <Box width="50%" padding="0px 6px">
          <MyTimesheetCalendarTooltipState
            state={
              ["requested", "approved", "recorded", "rejected"].includes(
                event?.state as string,
              )
                ? (event?.state as
                  | "requested"
                  | "approved"
                  | "recorded"
                  | "rejected")
                : "requested"
            }
          />
        </Box>
      </Box>
    </Box>
  );
};

export default MyTimesheetCalendarTooltip;
